import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgCreateNewConversation = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19" {...props}>
    <g fill="none" fillRule="evenodd">
      <path fill="#1BBBC9" d="M9 1a9 9 0 1 1 0 18A9 9 0 0 1 9 1z" />
      <path fill="#1BBBC9" d="M4 6.477h4v7H4z" />
      <path
        stroke="#FFF"
        d="M7.713 6.5a.2.2 0 0 0-.2.2L7.5 12.3c0 .11.09.2.2.2h6.6a.2.2 0 0 0 .2-.2V6.7a.2.2 0 0 0-.2-.2H7.713z"
      />
      <path fill="#1BBBC9" d="M5 7h3v5H5z" />
      <path stroke="#FFF" strokeLinecap="round" d="m8 7 2.966 2L14 7" />
      <path fill="#FFF" d="M4.4 6.477h1v6h-1z" />
      <path fill="#FFF" d="M8 8.877v1H2v-1z" />
    </g>
  </svg>
);
const Memo = memo(SvgCreateNewConversation);
export default Memo;
